(function () {
  function init(root) {
    if (!root || root.dataset.gettmiJustInReady === 'true') return;
    var track = root.querySelector('[data-gettmi-just-in-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gettmi-just-in-dot]'));
    if (!track || dots.length < 2) return;
    root.dataset.gettmiJustInReady = 'true';

    var frame = 0;
    function select(index) {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        track.scrollLeft = index * track.clientWidth;
        select(index);
      });
    });

    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var width = track.clientWidth || 1;
        select(Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / width))));
      });
    }, { passive: true });
  }

  function run() {
    document.querySelectorAll('[data-gettmi-just-in]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
